module.exports = __webpack_public_path__ + "static/media/redlipstick.72738fcf.jpg";